<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Landowner', apiMethod: 'Landowners', form: () => import('../forms/LandownerForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Sites', value: 'landownerId', table: () => import('../tables/SitesTable') },
                ],
                mainForm: () => import('../forms/LandownerForm'),
                claimName: 'Landowners',
                apiMethod: 'Landowners',
            }
        }
    };
</script>
